<template>
<div class="chapter">
<div class="inner_page">
<p class="ct" id="d6e158311"><b>Top Ten Benefits <i>of Having Healthy Self-Esteem </i></b></p>
<p class="tx" id="d6e159111"><b>1. </b>You are more secure in who you are and what you have to offer the world.</p>
<p class="tx" id="d6e160311"><b>2. </b>You are able to see the good in others and in the world around you.</p>
<p class="tx" id="d6e161211"><b>3. </b>You are able to move on from the past and experience joy in the present.</p>
<p class="tx" id="d6e162411"><b>4. </b>Your are able to overcome adversity and setbacks more easily.</p>
<p class="tx" id="d6e163111"><b>5. </b>You are able to forgive yourself and others.</p>
<p class="tx" id="d6e164111"><b>6. </b>You have a clear sense of your own values, worth, integrity, and character.</p>
<p class="tx" id="d6e165311"><b>7. </b>You take better care of your physical and mental health.</p>
<p class="tx" id="d6e166211"><b>8. </b>You are able to develop a positive philosophy of life and live by that philosophy.</p>
<p class="tx" id="d6e167411"><b>9. </b>You are more optimistic, happier, and able to give of yourself to others.</p>
<p class="tx" id="d6e168611"><b>10. </b>You are able to take responsibility for your own thoughts, actions, and indeed, your life.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Sher_9781440522697_epub_c8_r1.vue?1286106a